import { Component,OnInit } from '@angular/core';
import { Router,NavigationEnd } from '@angular/router';

import * as AOS from 'aos';
import { LogoutService } from './services/logout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  loader:any;
  title = 'deski';
  message = '';
  alert_type = 'success';
  isAlertShow = false;
  isMessageShow = false;


  constructor (private router : Router, private logoutService: LogoutService) {}

  ngOnInit(){
    AOS.init({
      duration:1600
    });

    this.router.events.subscribe((evt) => {
      if(! (evt instanceof NavigationEnd)){
        return
      }
      window.scrollTo(0,0)
    })
  }

  showLoader(){
    this.loader =  true;
  }

  hideLoader(){
    this.loader = false;
  }

  showMessageAlert(_message: any, _type: any){
    this.message = _message;
    this.alert_type = _type;
    this.isAlertShow = true;
      setTimeout(() => this.isAlertShow = false, 3000);
  
    }

    logout(){
      console.log('=== APP COMPONENT LOGOUT START ===');
      this.showLoader();
      console.log('Calling logoutService.logout()...');
      
      const logoutObservable = this.logoutService.logout();
      console.log('Received Observable from service:', logoutObservable);
      console.log('Starting subscription...');
      
      logoutObservable.subscribe({
        next: (res: any) => {
          console.log('NEXT: AppComponent received response:', res);
          if (res.success !== false) {
            this.showMessageAlert('You Logged Out Successfully.', 'success');
          } else {
            this.showMessageAlert(res.error || 'Logout failed', 'error');
          }
          this.hideLoader();
        },
        error: (error) => {
          console.error('ERROR: AppComponent subscription error:', error);
          this.showMessageAlert('Logout failed', 'error');
          this.hideLoader();
        },
        complete: () => {
          console.log('COMPLETE: AppComponent logout subscription completed');
        }
      });
      
      console.log('=== SUBSCRIPTION INITIATED ===');
    }

}
